import { toRem } from "./articleMagazinePreviewTokens";

export const magazinePageContentSx = {
  fontFamily: "Rubik, sans-serif",
  px: { xs: 2, sm: 3, md: 4 },
  pt: { xs: 3, md: 4 },
  pb: { xs: 8, md: 10 },
  maxWidth: toRem(1290),
  mx: "auto",
  width: "100%",
  boxSizing: "border-box",
};

export const magazineArticlesGridSx = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: { xs: 2, md: 2.5 },
  mt: 3,
  width: "100%",
};

export const magazineArticlesSectionSx = {
  width: "100%",
  maxWidth: toRem(960),
  mx: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const magazineArticleHeaderBlockSx = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2,
  mt: 2,
  width: "100%",
  mx: "auto",
};

export const magazineArticleTitleSx = {
  color: "#054297",
  fontWeight: 600,
  fontSize: { xs: toRem(28), md: toRem(40) },
  lineHeight: 1.1,
  textAlign: "center",
  width: "100%",
  maxWidth: toRem(840),
  mx: "auto",
};

export const magazineArticleSubtitleSx = {
  color: "#000000",
  fontSize: toRem(17),
  lineHeight: toRem(23),
  textAlign: "center",
  width: "100%",
  maxWidth: toRem(608),
  mx: "auto",
};

export const magazineLinkedArticlesSectionTitleSx = {
  color: "#054297",
  fontWeight: 600,
  fontSize: { xs: toRem(24), md: toRem(32) },
  lineHeight: 1.1,
  textAlign: "center",
  mt: { xs: 5, md: 7 },
  mb: 3,
};

export const magazineSectionTitleSx = {
  color: "#054297",
  fontWeight: 600,
  fontSize: { xs: toRem(28), md: toRem(40) },
  lineHeight: 1.1,
  textAlign: "center",
  mt: { xs: 5, md: 7 },
  mb: 3,
};

export const magazineCategoryBadgeSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "fit-content",
  maxWidth: "100%",
  alignSelf: "center",
  minHeight: toRem(34),
  px: 2,
  borderRadius: toRem(21),
  border: "1px solid #ffffff",
  backgroundColor: "#054297",
  color: "#ffffff",
  fontWeight: 600,
  fontSize: toRem(15),
  textTransform: "uppercase",
};

export const magazineMetaPillSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1.5,
  minHeight: toRem(34),
  px: 2,
  borderRadius: toRem(20),
  border: "1px solid #054297",
  backgroundColor: "#f7f6f6",
  color: "#054297",
  fontSize: toRem(15),
};

export const magazineSuggestedProductChipSx = {
  display: "inline-flex",
  alignItems: "center",
  minHeight: toRem(40),
  px: 2,
  borderRadius: toRem(20),
  border: "1px solid #054297",
  backgroundColor: "#ffffff",
  color: "#054297",
  fontWeight: 600,
  fontSize: toRem(15),
};

export const magazineArticleBodyContentSx = {
  width: "93%",
  maxWidth: "93%",
  mx: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: 2.5,
  boxSizing: "border-box",
};

export const articleBodyParagraphSx = {
  color: "#000000",
  fontSize: toRem(17),
  lineHeight: toRem(30),
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  display: "block",
  boxSizing: "border-box",
  width: "100%",
  maxWidth: "100%",
  margin: 0,
  "& strong": {
    fontWeight: 600,
  },
  "& em": {
    fontStyle: "italic",
  },
};

export const magazineSuggestedProductsSectionSx = {
  mt: 6,
  width: "100%",
  alignSelf: "stretch",
};

export const magazineSuggestedProductsTitleSx = {
  color: "#054297",
  fontWeight: 600,
  fontSize: toRem(20),
  lineHeight: 1.3,
  textAlign: "left",
  mb: 1.5,
};

export const magazineSuggestedProductsLinksSx = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  width: "100%",
  color: "#000000",
  fontSize: toRem(17),
  lineHeight: toRem(30),
};

export const magazineSuggestedProductItemSx = {
  display: "inline-flex",
  alignItems: "center",
  flexShrink: 0,
  whiteSpace: "nowrap",
  maxWidth: "100%",
};

export const magazineSuggestedProductLinkSx = {
  color: "#000000",
  textDecoration: "underline",
  fontSize: toRem(17),
  lineHeight: toRem(30),
  whiteSpace: "nowrap",
  flexShrink: 0,
};
